import styles from "./Blog.module.scss";
import classNames from "classnames/bind";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
const cx = classNames.bind(styles);
function Blog({ data }) {
    console.log(data);
    console.log("hình");
    const mediaQuery = window.matchMedia("(min-width: 768px)").matches;
    return (
        <div className={cx("blog")}>
            <div className={cx("wrapper")}>
                {!mediaQuery && <h3>Tin mới</h3>}
                <div className={cx("blog_item")}>
                    <img
                        alt=""
                        src="https://cdn.topteknews.net/wp-content/uploads/2022/07/27151742/image-lamborghini-huracan-sterrato-video-teaser-165888466276876.jpg"
                    />
                    <div className={cx("blog_info")}>
                        <h3 className={cx("blog_title")}>
                            Lorem ipsum, or lipsum as it is sometimes known, is
                            dummy text used in laying out print,
                        </h3>
                        {mediaQuery && (
                            <p className={cx("blog_descripton")}>
                                Tổng lượng tiêu thụ ô tô toàn thị trường Việt
                                tháng 7/2022 bất ngờ quay đầu tăng tốc trở lại
                                sau tháng liền kề giảm mạnh. Tính riêng tính
                                riêng doanh số bán hàng của các đơn vị thành
                            </p>
                        )}

                        <div>
                            <div className={cx("blog_brand")}>Lamborghini</div>
                            <div className={cx("blog_author")}>Admin</div>
                        </div>
                    </div>
                </div>{" "}
                <div className={cx("blog_item")}>
                    <img
                        alt=""
                        src="https://cdn.topteknews.net/wp-content/uploads/2022/07/27151742/image-lamborghini-huracan-sterrato-video-teaser-165888466276876.jpg"
                    />
                    <div className={cx("blog_info")}>
                        <h3 className={cx("blog_title")}>
                            Lorem ipsum, or lipsum as it is sometimes known, is
                            dummy text used in laying out print,
                        </h3>
                        {mediaQuery && (
                            <p className={cx("blog_descripton")}>
                                Tổng lượng tiêu thụ ô tô toàn thị trường Việt
                                tháng 7/2022 bất ngờ quay đầu tăng tốc trở lại
                                sau tháng liền kề giảm mạnh. Tính riêng tính
                                riêng doanh số bán hàng của các đơn vị thành
                            </p>
                        )}

                        <div>
                            <div className={cx("blog_brand")}>Lamborghini</div>
                            <div className={cx("blog_author")}>Admin</div>
                        </div>
                    </div>
                </div>{" "}
                <div className={cx("blog_item")}>
                    <img
                        alt=""
                        src="https://cdn.topteknews.net/wp-content/uploads/2022/07/27151742/image-lamborghini-huracan-sterrato-video-teaser-165888466276876.jpg"
                    />
                    <div className={cx("blog_info")}>
                        <h3 className={cx("blog_title")}>
                            Lorem ipsum, or lipsum as it is sometimes known, is
                            dummy text used in laying out print,
                        </h3>
                        {mediaQuery && (
                            <p className={cx("blog_descripton")}>
                                Tổng lượng tiêu thụ ô tô toàn thị trường Việt
                                tháng 7/2022 bất ngờ quay đầu tăng tốc trở lại
                                sau tháng liền kề giảm mạnh. Tính riêng tính
                                riêng doanh số bán hàng của các đơn vị thành
                            </p>
                        )}

                        <div>
                            <div className={cx("blog_brand")}>Lamborghini</div>
                            <div className={cx("blog_author")}>Admin</div>
                        </div>
                    </div>
                </div>{" "}
                <div className={cx("blog_item")}>
                    <img
                        alt=""
                        src="https://cdn.topteknews.net/wp-content/uploads/2022/07/27151742/image-lamborghini-huracan-sterrato-video-teaser-165888466276876.jpg"
                    />
                    <div className={cx("blog_info")}>
                        <h3 className={cx("blog_title")}>
                            Lorem ipsum, or lipsum as it is sometimes known, is
                            dummy text used in laying out print,
                        </h3>
                        {mediaQuery && (
                            <p className={cx("blog_descripton")}>
                                Tổng lượng tiêu thụ ô tô toàn thị trường Việt
                                tháng 7/2022 bất ngờ quay đầu tăng tốc trở lại
                                sau tháng liền kề giảm mạnh. Tính riêng tính
                                riêng doanh số bán hàng của các đơn vị thành
                            </p>
                        )}

                        <div>
                            <div className={cx("blog_brand")}>Lamborghini</div>
                            <div className={cx("blog_author")}>Admin</div>
                        </div>
                    </div>
                </div>{" "}
                <Link to="" className={cx("more_btn")}>
                    Xem thêm
                    <div>
                        <FontAwesomeIcon icon={faAngleDown} />
                    </div>
                </Link>
            </div>
            {data}
        </div>
    );
}

export default Blog;
